import { transitions, positions } from 'react-alert';

// https://github.com/schiehll/react-alert
// offset: PropTypes.string // the margin of each alert
// position: PropTypes.oneOf([
//   'top left',
//   'top right',
//   'top center',
//   'middle left',
//   'middle',
//   'middle right',
//   'bottom left',
//   'bottom right',
//   'bottom center'
// ]) // the position of the alerts in the page
// timeout: PropTypes.number // timeout to alert remove itself, if  set to 0 it never removes itself
// type: PropTypes.oneOf(['info', 'success', 'error']) // the default alert type used when calling this.props.alert.show
// transition: PropTypes.oneOf(['fade', 'scale']) // the transition animation
// containerStyle: PropTypes.Object // style to be applied in the alerts container
// template: PropTypes.oneOfType([PropTypes.element, PropTypes.func]).isRequired // the alert template to be used
// -------------------------------------------------------
// export const positions = {
//     TOP_LEFT: 'top left',
//     TOP_CENTER: 'top center',
//     TOP_RIGHT: 'top right',
//     MIDDLE_LEFT: 'middle left',
//     MIDDLE: 'middle',
//     MIDDLE_RIGHT: 'middle right',
//     BOTTOM_LEFT: 'bottom left',
//     BOTTOM_CENTER: 'bottom center',
//     BOTTOM_RIGHT: 'bottom right'
//   }
  
//   export const types = {
//     INFO: 'info',
//     SUCCESS: 'success',
//     ERROR: 'error'
//   }
  
//   export const transitions = {
//     FADE: 'fade',
//     SCALE: 'scale'
//   }
  

// Normal alert options
export const normalAlertOptions = {
  position: positions.BOTTOM_CENTER,
  timeout: 3000,
  offset: '30px',
  transition: transitions.FADE,
};

// Error alert options
export const errorAlertOptions = {
  position: positions.BOTTOM_RIGHT,
  timeout: 5000,
  offset: '30px',
  transition: transitions.FADE,
  type: 'error',
  icon: 'error-icon',
  containerStyle: {
    backgroundColor: 'red',
    color: 'white',
  },
//   containerClassName: 'custom-alert-container'
};
